import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { IProductService, IProductServiceToken } from 'projects/shared/lib/services/data/product/product-service.interface';
import { IComparisonService, IComparisonServiceToken } from 'projects/shared/lib/services/infrastructure/comparison/comparison-service.interface';
import { EPromotionType, PercentageFractureDto, ProductIdentifierDto, ProductPromotionDetailDto, ProductPromotionDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-promotion-info-base',
  imports: [
    CommonModule
  ],
  template: '',
  styleUrls: []
})
export class PromotionInfoBaseComponent implements OnInit {

  private readonly productService: IProductService;
  private readonly comparisonService: IComparisonService;

  @Input() public promotionData: ProductPromotionDto | undefined;
  @Input() public promotionDetail: ProductPromotionDetailDto | undefined;

  public ePromotionType: typeof EPromotionType;
  public quantityPerAdditionalDifference: number | undefined;
  public quantityUnitsAreEqual: boolean | undefined;
  public additionalProductDescription: string | undefined;
  public percentageDiscount: string | undefined;

  public constructor() {
    this.productService = inject(IProductServiceToken);
    this.comparisonService = inject(IComparisonServiceToken);

    this.ePromotionType = EPromotionType;
  }

  public ngOnInit(): void {
    if (this.promotionData == undefined) {
      this.reset();
      return;
    }
    this.handle(this.promotionData);
  }

  private handle(promotionDetail: ProductPromotionDto) {
    this.quantityUnitsAreEqual = promotionDetail.perQuantityUnit?.quantityUnit == promotionDetail.additionQuantityUnit?.quantityUnit;

    switch (promotionDetail.promotionType) {
      case EPromotionType.FreeProduct:
        this.loadProductDetailAsync(promotionDetail.additionProductNumber);
        break;
      case EPromotionType.FreeInclusive:
        if (this.quantityUnitsAreEqual == true) {
          this.quantityPerAdditionalDifference = promotionDetail.perQuantity - promotionDetail.additionQuantity;
        }
        break;
      case EPromotionType.FreeExclusive:
        break;

      case EPromotionType.PercentageDiscount:
        if (this.promotionData?.percentageDiscount != undefined) {
          this.getPercentageDiscounnt(this.promotionData.percentageDiscount);
        }
        break;

      default:
        throw new Error(`Missing implementation of EPromotionType for case (${promotionDetail.promotionType} in promotion info.)`);
    }
  }

  private reset() {
    this.quantityPerAdditionalDifference = undefined;
    this.quantityUnitsAreEqual = undefined;
  }

  private async loadProductDetailAsync(additionProductNumber?: string | undefined) {
    if (additionProductNumber == undefined || additionProductNumber.length <= 0) { return; }

    let additionalProductIdentifier = new ProductIdentifierDto({ productNumber: additionProductNumber });
    // Note: property reference productService was added while introducting injectionTokens. MIGHT crash due to async function. 22.05.2025
    await firstValueFrom(this.productService.productDetailGet(false, false, false, false, false, false, false, undefined, [additionalProductIdentifier])).then((result) => {
      let productDetail = result.productList?.find(p => this.comparisonService.equalsProductIdentifierByNumberOrGuid(p.productIdentifier, additionalProductIdentifier));
      if (productDetail?.description != undefined && productDetail?.description.length > 0) {
        this.additionalProductDescription = productDetail.description;
      } else {
        this.additionalProductDescription = undefined;
      }
    }).catch((error) => {
      let errorMessage = $localize`:@@PromotionInfoProductLoadErrorMessage:Could not load product details`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });

  }

  private getPercentageDiscounnt(percentageFracture: PercentageFractureDto) {
    if (percentageFracture.numerator != undefined && percentageFracture.denominator != undefined) {
      let percentageDiscount = percentageFracture.numerator / percentageFracture.denominator * 100;
      this.percentageDiscount = percentageDiscount.toFixed(0);
    }
  }
}
